<template>
  <div class="s_system_config_base g-flex-column" v-show="show">
    <el-form ref="form" :model="form" label-width="200px" label-position="right">
      <el-row :gutter="24">
        <el-col :span="22">
          <el-form-item label="用户推广内容: ">
            <el-input  type="textarea" :autosize="{ minRows: 8, maxRows: 12 }" placeholder="请输入内容" v-model="form.buy_spread"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="用户推广商家内容: ">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 12 }" placeholder="请输入内容"  v-model="form.shop_spread"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" size="large" @click="submitClick">确定修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { apiGetSystemConfig, apiSetSystemConfig } from '@/utils/api.js'
  export default {
    data() {
      return {
        code: '',
        show: false,
        form: {
          buy_spread: '',
          shop_spread: '',
        }
      }
    },
    methods: {
      onShow(code) {
        this.code = code
        this.show = true
        this.apiGetSystemConfigHandel()
      },

      async apiGetSystemConfigHandel() {
        let loading = this.$loading()
        const { success, data } = await apiGetSystemConfig({ code: this.code}).catch(() => loading.close())
        loading.close()
        if(!success) return
        this.form = data.data
        console.log(data)
      },

      async submitClick() {
        let loading = this.$loading()
        const { success, data } = await apiSetSystemConfig({ code: this.code, config: this.form }).catch(() => loading.close())
        loading.close()
        if(!success) return
        this.$message.success(data.msg)
      },
    }

  }
</script>

<style lang="scss">
.s_system_config_base {
  .s-system-config-base-btn {
    padding-top: 30px;
  }
}
</style>